<section class="{{ class }}">
  <lib-success-message></lib-success-message>
  <lib-new-contract></lib-new-contract>
</section>
